import { render, staticRenderFns } from "./OrganizationLibrary.vue?vue&type=template&id=de472a5a&scoped=true"
import script from "./OrganizationLibrary.vue?vue&type=script&lang=js"
export * from "./OrganizationLibrary.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLibrary.vue?vue&type=style&index=0&id=de472a5a&prod&lang=scss&scoped=true"
import style1 from "./OrganizationLibrary.vue?vue&type=style&index=1&id=de472a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de472a5a",
  null
  
)

export default component.exports